import React, { useEffect, useState } from 'react'
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import { statisticsCollection } from '../utils/firebase'
import toast from 'react-hot-toast'
import NewRegisterPendingList from '../components/new-register-pending-list'
import RegisterEventPendingList from '../components/register-event-pending-list'

export default function Admin() {
  const [homePageStatistic, setHomePageStatistic] = useState({
    events: 0,
    fighters: 0,
    attendees: 0,
  })

  const handleSaveHomePageStatistic = async () => {
    toast.promise(updateDoc(doc(statisticsCollection, "home_page"), { ...homePageStatistic }), {
      loading: "Updating",
      success: "Updated",
      error: "Something went wrong"
    })
  }

  useEffect(() => {
    (async () => {
      const statisticSnapshot = await getDoc(doc(statisticsCollection, "home_page"))
      if (statisticSnapshot.exists()) {
        setHomePageStatistic(statisticSnapshot.data())
      }
    })()
  }, [])

  return (
    <div className="page-size flex flex-col gap-4 justify-start p-4">
      <p className='font-bold text-3xl'>MFL Portal</p>
      <div className='flex flex-col lg:flex-row justify-between lg:items-center gap-2 flex-wrap'>
        <p className=''>Landing Page Statistic: </p>
        <div className="flex flex-col md:flex-row gap-2">
          <label className='input input-bordered flex flex-row items-center'>
            <input placeholder='Events' type="number" name="" id="" value={homePageStatistic.events} onChange={((e) => setHomePageStatistic((prev) => ({ ...prev, events: e.target.value })))} />
            <span>_</span>
          </label>
          <label className='input input-bordered flex flex-row items-center'>
            <input placeholder='Fighters' type="number" name="" id="" value={homePageStatistic.fighters} onChange={((e) => setHomePageStatistic((prev) => ({ ...prev, fighters: e.target.value })))} />
            <span>_</span>
          </label>
          <label className='input input-bordered flex flex-row items-center'>
            <input placeholder='Attendees' type="number" name="" id="" value={homePageStatistic.attendees} onChange={((e) => setHomePageStatistic((prev) => ({ ...prev, attendees: e.target.value })))} />
            <span>K</span>
          </label>
          <button className='btn btn-primary' disabled={homePageStatistic.fighters === null} onClick={handleSaveHomePageStatistic}>
            Save
          </button>
        </div>
      </div>
      <div className='flex flex-col md:flex-row w-full max-h-auto md:max-h-[90vh] md:min-h-[calc(100vh-10rem)] gap-2 items-stretch justify-between'>
        <div className="border w-full min-h-[30vh] md:min-h-none overflow-auto">
          <NewRegisterPendingList />
        </div>
        <div className="border w-full min-h-[30vh] md:min-h-none overflow-auto">
          <RegisterEventPendingList />
        </div>

      </div>
    </div>
  )
}
